import type { Category } from "./DocumentationNavItem";

type Args = {
  activeHeadingId: string;
  depth: number;
  category: Category;
  isFirstSubCategory: boolean;
  pathname: string;
  scrollY: number;
};

export const isActiveCategory = ({
  activeHeadingId,
  depth,
  category,
  isFirstSubCategory,
  pathname,
  scrollY,
}: Args) => {
  if (activeHeadingId && depth !== 1) {
    const hash = `#${activeHeadingId}`;
    const matchesSelf = category.link.endsWith(hash);
    const matchesChild =
      category.subCategories?.some(subCategory => subCategory.link.endsWith(hash)) ?? false;

    if (matchesSelf || matchesChild) return true;
  } else if (pathname === category.link) {
    return true;
  }

  if (activeHeadingId && scrollY === 0 && isFirstSubCategory) return true;

  return false;
};
